import { GTP } from "@/types/user";
import { useEffect } from "react";
import { create } from "zustand";

interface GTPState {
  refreshKey: number;
  isGTP: boolean;
  setIsGTP: (notif: any) => void;
  currentGTP: GTP | null;
  setCurrentGTP: (gtp: GTP | null) => void;
}

export const useGTPStore = create<GTPState>((set) => ({
  refreshKey: 0,
  isGTP: false,
  setIsGTP: (notif) => set({ isGTP: notif }),
  currentGTP: null,
  setCurrentGTP: (gtp) => set({ currentGTP: gtp }),
}));

const useCurrentGTP = () => {
  const { currentGTP, setCurrentGTP } = useGTPStore();

  function SetCurrentGTP(gtp: GTP | null) {
    localStorage.setItem("ACTIVE_GTP", JSON.stringify(gtp));
    setCurrentGTP(gtp);
  }

  useEffect(() => {
    if (!currentGTP) {
      const gtp = localStorage.getItem("ACTIVE_GTP");
      if (gtp) {
        setCurrentGTP(JSON.parse(gtp));
      }
    }
  }, [currentGTP, setCurrentGTP]);

  return { currentGTP, SetCurrentGTP };
};

export default useCurrentGTP;
